import React from 'react';
import Input from "../Input-new/Input";
import PropTypes from "prop-types";
import Control from "../Control";
import Dropdown from "../Dropdown/Dropdown";

const LenderForm = ({theme = 'white', width, data, paneIndex, isFilter = false, handleSubmit, handleCancel, handleParentChange, handlePaneChange, handleParentDropdownChange}) => {
    const panes = [
        (
            <React.Fragment>
                <div className={`form-title ${theme}`}>{isFilter ? 'Lender' : 'Add Lender'}</div>
                <Input theme={theme}
                       width={width}
                       valueType='text'
                       name='NAME'
                       label='Lender Name'
                       value={data.NAME}
                       required={!isFilter}
                       handleParentChange={handleParentChange}
                />
                <Input theme={theme}
                       width={width}
                       valueType='text'
                       name='CITY'
                       label='City'
                       value={data.CITY}
                       handleParentChange={handleParentChange}
                />
                <Dropdown
                    theme={theme}
                    data={data}
                    optionsType="states"
                    optionKey="abbr"
                    optionLabelKey="name"
                    value={data.STATE}
                    valueKey="STATE"
                    label="State"
                    handleParentChange={handleParentDropdownChange}
                />
                <Input theme={theme}
                       width={width}
                       valueType='text'
                       name='CONTACT_NAME'
                       label='Contact Name'
                       value={data.CONTACT_NAME}
                       handleParentChange={handleParentChange}
                />
                <Input theme={theme}
                       width={width}
                       valueType='phone'
                       name='CONTACT_PHONE'
                       label='Phone #'
                       value={data.CONTACT_PHONE}
                       handleParentChange={handleParentChange}
                />
                <Input theme={theme}
                       width={width}
                       valueType='email'
                       name='CONTACT_EMAIL'
                       label='Email'
                       value={data.CONTACT_EMAIL}
                       handleParentChange={handleParentChange}
                />
            </React.Fragment>
        ),
    ];

    return (
        <form className='form' onSubmit={handleSubmit}>
            <div className='form-slider'>
                {
                    panes.map((el, key) => (
                        <Control key={key} onClick={()=> handlePaneChange(key)}>
                            <div className={`form-slider-icon ${theme}${key === paneIndex ? ' active' : ''}`}/>
                        </Control>
                    ))
                }
            </div>
            {
                panes[paneIndex]
            }
            {
                isFilter ?
                    <div className='filter-buttons'>
                        <button type='button' className='button-new negative dark' onClick={handleCancel}>Clear</button>
                        <button className='button-new positive'>Apply</button>
                    </div>
                    :
                    <React.Fragment>
                        <button type='button' className='button-new negative' onClick={handleCancel}>Cancel</button>
                        <button className='button-new positive'>Submit</button>
                    </React.Fragment>
            }
        </form>
    )
};

LenderForm.propTypes = {
    theme: PropTypes.oneOf(['white', 'dark']),
    width: PropTypes.number,
    data: PropTypes.object.isRequired,
    paneIndex: PropTypes.number.isRequired,
    isFilter: PropTypes.bool,
    handleSubmit: PropTypes.func.isRequired,
    handleCancel: PropTypes.func.isRequired,
    handleParentChange: PropTypes.func.isRequired,
    handleParentDropdownChange: PropTypes.func.isRequired,
    handlePaneChange: PropTypes.func.isRequired,
};

export default LenderForm;